import { useCallback } from 'react';

import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useGetDynamicBalances = () => {
    const send = useGenericSend();

    return useCallback(async (
        request: Types.IGetDynamicBalancesRequestData,
        options?: { signal?: AbortSignal }
    ): Promise<Types.IGetDynamicBalancesResponseData> => {
            const { data } = await send<Types.IGetDynamicBalancesRequestData, Types.IGetDynamicBalancesResponseData>({
                ID: 31020,
                responses: [31021, 31025],
                description: 'Get Dynamic Balance',
                errorLevel: 1,
                ...request
            }, options);

            return data;
        }, [
            send
        ]);
};
